import React, { useState, useEffect } from 'react';
import './AboutRestaurant.css';

// Restaurant images from assets folder

const AboutRestaurant = ({ settings = {} }) => {
  console.log('AboutRestaurant component loaded with settings:', settings);
  
  const {
    title = 'UNSER RESTAURANT IN WIPKINGEN',
    content = `Im gemütlichen und ruhigen Viertel Wipkingen gelegen, verwöhnt Restaurant Damas seine Gäste mit authentischer syrischer und orientalischer Küche. Die syrische Küche hat uns geprägt und sie ist es, die uns Heimweh und Entfernung vergessen lässt. Weit weg von Betlehem, Beirut und Damaskus hoffen wir, dass auch Sie sich bei uns heimisch fühlen.

Die Kunden loben das unbeschreiblich feine Essen und die schöne Einrichtung des Restaurants. Das Personal wird als sehr freundlich und aufmerksam gelobt, was zu einem insgesamt angenehmen Besuch beiträgt.`,

    gallery_images = [], // Array of Shopify images from admin
    default_images = [], // Default images from Liquid
    background_color = '#f8f9ff',
    text_color = '#333333',
    accent_color = '#4A90E2',
    layout = 'image-right', // 'image-left', 'image-right', 'image-top'
    slider_autoplay = true,
    slider_autoplay_delay = 4000
  } = settings;

  // Use Shopify images if available, otherwise use default images from Liquid
  const images = gallery_images.length > 0 ? gallery_images : default_images;
  
  console.log('Gallery images from settings:', gallery_images);
  console.log('Default images from Liquid:', default_images);
  console.log('Final images array:', images);
  
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-play functionality
  useEffect(() => {
    if (slider_autoplay && images.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide(prev => (prev + 1) % images.length);
      }, slider_autoplay_delay);
      
      return () => clearInterval(interval);
    }
  }, [images.length, slider_autoplay, slider_autoplay_delay]);

  const formatContent = (text) => {
    return text.split('\n\n').map((paragraph, index) => (
      <p key={index} className="about-restaurant__paragraph">
        {paragraph}
      </p>
    ));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? images.length - 1 : prev - 1);
  };

  const goToNextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % images.length);
  };

  return (
    <section className="about-restaurant" style={{ backgroundColor: background_color, color: text_color }}>
      <div className="about-restaurant__container">
        <div className={`about-restaurant__content about-restaurant__content--${layout}`}>
          <div className="about-restaurant__text-area">
            <h2 className="about-restaurant__title" style={{ color: accent_color }}>
              {title}
            </h2>
            <div className="about-restaurant__text">
              {formatContent(content)}
            </div>
          </div>
          
          {images.length > 0 && (
            <div className="about-restaurant__slider-area">
              <div className="about-restaurant__slider">
                <div className="about-restaurant__slider-container">
                  <div 
                    className="about-restaurant__slider-track"
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                  >
                    {images.map((image, index) => (
                      <div key={index} className="about-restaurant__slide">
                        <img 
                          src={typeof image === 'string' ? image : image}
                          alt={`${title} - Image ${index + 1}`}
                          className="about-restaurant__slide-image"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Navigation Arrows */}
                {images.length > 1 && (
                  <>
                    <button 
                      className="about-restaurant__slider-arrow about-restaurant__slider-arrow--prev"
                      onClick={goToPrevSlide}
                      style={{ color: accent_color }}
                    >
                      ‹
                    </button>
                    <button 
                      className="about-restaurant__slider-arrow about-restaurant__slider-arrow--next"
                      onClick={goToNextSlide}
                      style={{ color: accent_color }}
                    >
                      ›
                    </button>
                  </>
                )}

                {/* Dots Navigation */}
                {images.length > 1 && (
                  <div className="about-restaurant__slider-dots">
                    {images.map((_, index) => (
                      <button
                        key={index}
                        className={`about-restaurant__slider-dot ${
                          index === currentSlide ? 'about-restaurant__slider-dot--active' : ''
                        }`}
                        onClick={() => goToSlide(index)}
                        style={{ 
                          backgroundColor: index === currentSlide ? accent_color : 'rgba(255,255,255,0.5)' 
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AboutRestaurant;